var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"286px"},attrs:{"id":"echartBox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }